module.exports = __webpack_public_path__ + "img/0b5ab9b.png";